class EventListeners {
    constructor() {
        this.bindings = [];
    }
    addListener(target, type, listener, option) {
        const binding = { target, type, listener, option };
        target.addEventListener(type, listener, option);
        this.bindings.push(binding);
        return binding;
    }
    removeListener(binding) {
        const index = this.bindings.indexOf(binding);
        if (index > -1) {
            const { target, type, listener, option } = this.bindings[index];
            target.removeEventListener(type, listener, option);
            this.bindings.splice(index, 1);
        }
    }
    removeListeners() {
        this.bindings.forEach(({ target, type, listener, option }) => {
            target.removeEventListener(type, listener, option);
        });
        this.bindings = [];
    }
}

export { EventListeners as E };

//# sourceMappingURL=EventListeners-38634b18.js.map